// extracted by mini-css-extract-plugin
export var active = "_gm-7";
export var blink = "_gm-8";
export var dropDownSelector = "_gm-4";
export var dropDownWrapper = "_gm-3";
export var fakeCursor = "_gm-6";
export var fontSizeButton = "_gm-9";
export var formQuillEditor = "_gm-0";
export var pressed = "_gm-a";
export var qlBlank = "_gm-1";
export var textFormattingToolbar = "_gm-2";
export var textToolbarOption = "_gm-5";